import { IQuestionModel } from '@care-portals/api-interfaces';

const antiAgingBelugaQuestions: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'antiAgingBeluga_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    extras: { sendToBeluga: false },
    reject: true,
    isLast: true,
    answer: {}
  },

  {
    class: 'ineligible',
    field: 'antiAgingBeluga_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    type: 'info',
    isLast: true,
    reject: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'antiAgingBeluga_complete',
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    extras: { sendToBeluga: false },
    isLast: true,
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'antiAgingBeluga_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'antiAgingBeluga_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'antiAgingBeluga_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBeluga_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.

I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'antiAgingBeluga_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_pregnancyConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'antiAgingBeluga_pregnancyConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'antiAgingBeluga_height',
    type: 'info',
    answer: {
      name: 'antiAgingBeluga_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'antiAgingBeluga_weight',
    type: 'info',
    answer: {
      name: 'antiAgingBeluga_weight',
      type: 'number',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'What is your primary reason for requesting this medication?',
    subLabel: 'Select all that apply',
    field: 'antiAgingBeluga_reason',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'antiAgingBeluga_reason_generalWellness',
          value: 'General wellness'
        },
        {
          key: 'antiAgingBeluga_reason_belugaAntiAging',
          value: 'Anti-Aging'
        },
        {
          key: 'antiAgingBeluga_reason_antioxidant',
          value: 'Antioxidant benefits'
        },
        {
          key: 'antiAgingBeluga_reason_energy',
          value: 'Boost energy'
        },
        {
          key: 'antiAgingBeluga_reason_skin',
          value: 'Brighten skin'
        },
        {
          key: 'antiAgingBeluga_reason_detox',
          value: 'Detoxification'
        },
        {
          key: 'antiAgingBeluga_reason_immune',
          value: 'Immune support'
        },
        {
          key: 'antiAgingBeluga_reason_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Are you currently experiencing any of the following?',
    subLabel: 'Select all that apply',
    field: 'antiAgingBeluga_symptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'antiAgingBeluga_symptoms_fatigue',
          value: 'Fatigue or Low Energy'
        },
        {
          key: 'antiAgingBeluga_symptoms_memory',
          value: 'Memory Issues'
        },
        {
          key: 'antiAgingBeluga_symptoms_concentration',
          value: 'Difficulty Concentrating'
        },
        {
          key: 'antiAgingBeluga_symptoms_depression',
          value: 'Depression or Anxiety'
        },
        {
          key: 'antiAgingBeluga_symptoms_sleep',
          value: 'Sleep Disorders'
        },
        {
          key: 'antiAgingBeluga_symptoms_pain',
          value: 'Chronic Pain'
        },
        {
          key: 'antiAgingBeluga_symptoms_other',
          value: 'Other'
        },
        {
          key: 'antiAgingBeluga_symptoms_none',
          value: 'None of these apply to me',
          uncheckOthers: true
        },
      ]
    }
  },
  {
    label: 'Please provide further information about this condition.',
    field: 'antiAgingBeluga_symptoms_other_details',
    type: 'info',
    answer: {
      name: 'antiAgingBeluga_symptoms_other_details',
      type: 'text',
      placeholder: 'Condition details'
    }
  },
  {
    label:
      'Have you ever received anti-aging treatment before with metformin, glutathione or NAD?',
    field: 'antiAgingBeluga_previousTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_previousTreatment_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBeluga_previousTreatment_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Did you experience any allergies or negative reactions to any of these?',
    educationalSlide: `- Metformin\n- Glutathione\n- NAD`,
    field: 'antiAgingBeluga_previousReactions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_previousReactions_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBeluga_previousReactions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please tell us more about what you used, when this was used, and what side effect you experienced.',
    field: 'antiAgingBeluga_previousReactions_details',
    type: 'info',
    answer: {
      name: 'antiAgingBeluga_previousReactions_details',
      type: 'text',
      placeholder: 'Previous treatment reaction details'
    }
  },
  {
    label:
      'Do you have a known history of glucose-6-phosphate dehydrogenase (G6PD) deficiency, chronic kidney disease (CKD) or liver cirrhosis?',
    field: 'antiAgingBeluga_kidneyLiver',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_kidneyLiver_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBeluga_kidneyLiver_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Are you currently undergoing treatment for cancer, including chemotherapy or radiation therapy?',
    field: 'antiAgingBeluga_cancerTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_cancerTreatment_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBeluga_cancerTreatment_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'antiAgingBeluga_otherInformation',
    type: 'info',
    answer: {
      name: 'antiAgingBeluga_otherInformation',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Informed Consent Statement)',
    type: 'select',
    educationalSlide: `You are requesting treatment with one or more lifestyle-enhancement therapies including MIC injections, Glutathione, NAD+ (Nicotinamide Adenine Dinucleotide), and/or topical GHK-Cu (copper peptide) to support metabolism, enhance energy production, promote cellular health, support skin health, and potentially provide anti-aging benefits. These therapies are not intended for treatment of any specific medical condition.

Purpose of This Consent
This form ensures you understand:
The reason for prescribing these product
Their potential benefits and risks
The off-label status of certain components
The monitoring and follow-up plan
Your responsibilities during treatment

Background Information
MIC+B12 combines lipotropic agents (Methionine, Inositol, Choline) with Vitamin B12 to aid fat metabolism and boost energy.

Vitamin B12 (cobalamin) is essential for red blood cell production, neurological function, and DNA synthesis. Deficiency can arise from dietary insufficiency (e.g., vegan diets), malabsorption, or interactions with medications such as Metformin or proton-pump inhibitors.

Glutathione is a natural antioxidant that reduces oxidative stress, supports detoxification, and enhances immune function.

NAD+ is a coenzyme vital for mitochondrial energy production, DNA repair, and overall cellular health.

Metformin is a prescription medication for type 2 diabetes that is being studied off-label for metabolic and anti-aging effects.

GHK-Cu is a copper peptide used in topical formulations to support skin health, including collagen production and overall skin appearance.

Off-Label Use Notice
Glutathione, NAD+, Metformin, and GHK-Cu are not FDA-approved for wellness or anti-aging indications. Their use in this program is off-label, intended solely for health optimization and lifestyle enhancement.

Potential Benefits
MIC+B12: Enhanced metabolism and fat burning
Vitamin B12: Improved energy, neurological health, and cognitive function
NAD+: Increased cellular energy and mitochondrial function
Glutathione: Detoxification and antioxidant protection
Metformin: Improved insulin sensitivity and metabolic efficiency

GHK-Cu: Support for skin health and appearance
All therapies: Increased vitality, reduced fatigue, and potential anti-aging effects

Potential Risks and Side Effects
MIC+B12
Common: Injection-site redness, swelling, pain; nausea; mild diarrhea
Serious: Allergic reaction (rash, itching, breathing difficulty); elevated liver enzymes; rare injection-site infection

Vitamin B12
Common: Mild diarrhea; skin rash or itching; headache; nausea
Rare: Severe allergic reactions (anaphylaxis); hypokalemia with rapid correction; exacerbation of acne or rosacea

Glutathione
Common: GI discomfort; headache; skin reactions (rash, itching)
Rare: Allergic reaction; localized skin lightening

NAD+
Common: Nausea; fatigue; flushing; headache; abdominal cramping; dizziness
Less common: Anxiety; sweating; muscle cramps; injection-site pain or swelling

Metformin
Common: GI upset (nausea, bloating, diarrhea)
Rare but serious: Lactic acidosis (especially with kidney or liver impairment); long-term vitamin B12 deficiency

GHK-Cu
Common: Mild skin irritation, redness, or sensitivity at the application site
Rare: Allergic reaction

Risks and Considerations
Allergic Reactions: Discontinue treatment and seek immediate care if you experience rash, swelling, or breathing difficulty.
Kidney Function: Use Metformin cautiously with impaired kidney function.
Supplement Interactions: Disclose all medications and supplements to avoid interactions, particularly those affecting absorption of Vitamin B12.

Monitoring and Follow-Up
Attend all scheduled follow-up visits for assessment of therapy response and side-effect monitoring.

Patient Responsibilities
By consenting to these therapies, you agree to:
Follow the prescribed treatment plan exactly
Report new or worsening symptoms promptly
Avoid altering dosage or frequency without medical approval
Attend all recommended follow-up appointments
Inform your provider of any changes in medications, supplements, or health status

Patient Acknowledgment and Consent
I have read and understood the information provided in this consent form.
I understand the potential risks and benefits of using this product and the off-label nature of this treatment.
I agree to adhere to the monitoring plan and to inform my healthcare provider of any side effects or concerns.
By selecting below, I voluntarily consent to the use of this product for the treatment of my symptoms.`,
    field: 'antiAgingBeluga_treatmentConsent',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_treatmentConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          key: 'antiAgingBeluga_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, I understand the risks and would like to proceed'
        }
      ]
    }
  },
  {
    label: 'Consent (Truthfulness)',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'antiAgingBeluga_truthConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBeluga_truthConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          key: 'antiAgingBeluga_truthConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  }
];

export default antiAgingBelugaQuestions;

